module.exports = __webpack_public_path__ + "img/WetSkyline.18710b0e.svg";